import { siteData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden bg-background-50 pt-16 md:pt-18"
    >
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 py-10 md:py-16 lg:py-20">
            <div className="flex-1 w-full">
              <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4">
                {siteData.heroTag}
              </span>

              <h1 className="font-heading font-extrabold text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
                {siteData.name}
                <br />
                <span className="text-primary-500">全民创作竞技平台</span>
              </h1>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-lg">
                {siteData.slogan}
              </p>

              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-6 max-w-xl">
                {siteData.heroIntro}
              </p>

              <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-6">
                {siteData.heroStats.map((stat) => (
                  <div key={stat.label} className="flex flex-col">
                    <span className="font-heading font-bold text-lg md:text-xl text-foreground-900">
                      {stat.value}
                    </span>
                    <span className="text-xs text-foreground-500">{stat.label}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center gap-3">
                <a
                  href={siteData.primaryCTA.href}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap no-underline"
                >
                  <i className="ri-rocket-line"></i>
                  {siteData.primaryCTA.text}
                </a>
                <a
                  href={siteData.secondaryCTA.href}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap no-underline border border-background-200/70"
                >
                  <i className="ri-send-plane-line"></i>
                  {siteData.secondaryCTA.text}
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md lg:max-w-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20creative%20community%20platform%20concept%2C%20diverse%20group%20of%20young%20people%20creating%20art%20and%20photography%2C%20colorful%20dynamic%20composition%2C%20warm%20energetic%20atmosphere%2C%20modern%20editorial%20illustration%20style%2C%20clean%20minimal%20background%20with%20soft%20gradients%2C%20creative%20tools%20and%20camera%20elements%2C%20youthful%20and%20inspiring%20mood&width=1000&height=800&seq=hero-main-2026&orientation=portrait"
                  alt="每日大赛mrds创作竞技平台主视觉"
                  className="w-full h-auto rounded-2xl object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}